function Pagination3({ pageInfo, nextClick, prevClick }) {
  function handleNextClicked() {
    nextClick(pageInfo.links?.next ?? null);
  }

  function handlePrevClicked() {
    prevClick(pageInfo.links?.prev ?? null);
  }
  return (
    <div className="d-md-flex align-items-center mt-3">
      <div className="me-md-auto text-md-left text-center mb-2 mb-md-0">
        Showing {pageInfo.meta.from} to {pageInfo.meta.to} of {pageInfo.meta.total} entries
      </div>
      <ul className="pagination mb-0 justify-content-center">
        <li className={!pageInfo.links?.prev ? "page-item disabled" : "page-item"}>
          <a onClick={() => handlePrevClicked()} className="page-link" href="#/">
            Previous
          </a>
        </li>
        <li className={!pageInfo.links?.next ? "page-item disabled" : "page-item"}>
          <a onClick={() => handleNextClicked()} className="page-link" href="#/">
            Next
          </a>
        </li>
        {/* <li className="page-item disabled"><a className="page-link" href="#/">{'<<'}</a></li>
                <li className="page-item"><a className="page-link" href="#/">1</a></li>
                <li className="page-item"><a className="page-link" href="#/">..</a></li>
                <li className="page-item"><a className="page-link" href="#/">99</a></li>
                <li className="page-item"><a className="page-link" href="#/">100</a></li>
                <li className="page-item"><a className="page-link" href="#/">101</a></li>
                <li className="page-item disabled"><a className="page-link" href="#/">..</a></li>
                <li className="page-item"><a className="page-link" href="#/">{lastPage}</a></li>
                <li className="page-item"><a className="page-link" href="#/">{'>>'}</a></li> */}
      </ul>
    </div>
  );
}

export default Pagination3;
